<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>短信设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">阿里短信设置</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="160px"
          style="width: 80%"
        >
          <el-form-item label="ACCESS_ID：" prop="ALIYUN_SMS_AK">
            <el-input
              v-model="form_data.ALIYUN_SMS_AK"
              placeholder="请输入阿里云ACCESS_ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="ACCESS_KEY：" prop="ALIYUN_SMS_AS">
            <el-input
              v-model="form_data.ALIYUN_SMS_AS"
              placeholder="请输入阿里云ACCESS_KEY"
            ></el-input>
          </el-form-item>
          <el-form-item label="短信签名：" prop="ALIYUN_SMS_SIGN_NAME">
            <el-input
              v-model="form_data.ALIYUN_SMS_SIGN_NAME"
              placeholder="请输入阿里云短信签名"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码模板：" prop="ALIYUN_SMS_YZM">
            <el-input
              v-model="form_data.ALIYUN_SMS_YZM"
              placeholder="请输入阿里云验证码模板"
            ></el-input>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:true,
      form_data: {
        ALIYUN_SMS_AK: "",
        ALIYUN_SMS_AS: "",
        ALIYUN_SMS_SIGN_NAME: "",
        ALIYUN_SMS_YZM: "",
      },
      postData: [],
      id: "",
      rules: {
        ALIYUN_SMS_AK: [
          { required: true, message: "请输入阿里云ACCESS_ID", trigger: "blur" },
        ],
        ALIYUN_SMS_AS: [
          {
            required: true,
            message: "请输入阿里云ACCESS_KEY",
            trigger: "blur",
          },
        ],
        ALIYUN_SMS_SIGN_NAME: [
          {
            required: true,
            message: "请输入阿里云短信签名",
            trigger: "blur",
          },
        ],
        ALIYUN_SMS_YZM: [
          {
            required: true,
            message: "请输入阿里云验证码模板",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    var that = this;
    that.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/Config/getSms").then((res) => {
        if (res) {
          that.form_data = res.data;
        }
        that.loading = false;
      });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/Config/sms";
        that.axios.post(url, formData).then(() => {
          that.$message.success("保存成功");
          that.$router.push('/Config/sms');
        });
      });
    },
  },
};
</script>
